import { render, staticRenderFns } from "./AppointmentCalendar.vue?vue&type=template&id=3a48fcfd&"
import script from "./AppointmentCalendar.vue?vue&type=script&lang=js&"
export * from "./AppointmentCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports